import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchWrapper } from '../../../../helpers';
import { TREATMENT_PLANS_V2_API_BASE } from '../../constants';

import type { ITherapy } from '../../../../pages/common';
import type {
  ITreatmentPlanV3TherapyPage,
  GetTreatmentPlanV3TherapyPagePayload,
  CreateTreatmentPlanV3TherapyPayload,
  UpdateTreatmentPlanV3TherapyPayload,
  DeleteTreatmentPlanV3TherapyPayload,
  SetTreatmentPlanV3NoTherapyPayload,
} from './types';

export function createTreatmentPlanV3TherapyThunks() {
  return {
    getTreatmentPlanV3TherapyPage: getTreatmentPlanV3TherapyPage(),
    createTreatmentPlanV3Therapy: createTreatmentPlanV3Therapy(),
    updateTreatmentPlanV3Therapy: updateTreatmentPlanV3Therapy(),
    deleteTreatmentPlanV3Therapy: deleteTreatmentPlanV3Therapy(),
    setTreatmentPlanV3NoTherapy: setTreatmentPlanV3NoTherapy(),
  };
}

function getTreatmentPlanV3TherapyPage() {
  return createAsyncThunk<ITreatmentPlanV3TherapyPage, GetTreatmentPlanV3TherapyPagePayload>(
    'treatmentPlanV3/getTreatmentPlanV3TherapyPage',
    async ({ treatmentPlanId, getAccessTokenSilently }) =>
      fetchWrapper.get({
        url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/therapy/`,
        getAccessTokenSilently,
      }),
  );
}

function createTreatmentPlanV3Therapy() {
  return createAsyncThunk<ITherapy, CreateTreatmentPlanV3TherapyPayload>(
    'treatmentPlanV3/createTreatmentPlanV3Therapy',
    async ({ treatmentPlanId, data, getAccessTokenSilently }) =>
      fetchWrapper.post(
        {
          url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/therapy/`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function updateTreatmentPlanV3Therapy() {
  return createAsyncThunk<ITherapy, UpdateTreatmentPlanV3TherapyPayload>(
    'treatmentPlanV3/updateTreatmentPlanV3Therapy',
    async ({ treatmentPlanId, therapyId, data, getAccessTokenSilently }) =>
      fetchWrapper.patch(
        {
          url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/therapy/${therapyId}/`,
          getAccessTokenSilently,
        },
        data,
      ),
  );
}

function deleteTreatmentPlanV3Therapy() {
  return createAsyncThunk<void, DeleteTreatmentPlanV3TherapyPayload>(
    'treatmentPlanV3/deleteTreatmentPlanV3Therapy',
    async ({ treatmentPlanId, therapyId, getAccessTokenSilently }) => {
      await fetchWrapper.delete({
        url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/therapy/${therapyId}/`,
        getAccessTokenSilently,
      });
    },
  );
}

function setTreatmentPlanV3NoTherapy() {
  return createAsyncThunk<ITreatmentPlanV3TherapyPage, SetTreatmentPlanV3NoTherapyPayload>(
    'treatmentPlanV3/setTreatmentPlanV3NoTherapy',
    async ({ treatmentPlanId, noTherapy, getAccessTokenSilently }) =>
      fetchWrapper.patch(
        {
          url: `${TREATMENT_PLANS_V2_API_BASE}/${treatmentPlanId}/pages/therapy/`,
          getAccessTokenSilently,
        },
        { no_historical_therapy: noTherapy },
      ),
  );
}
